import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import customConfirmationFGTY from "../../../../src/content/franklin-graham-thank-you-video-message-2024/customConfirmation";
import "../../../../src/content/franklin-graham-thank-you-video-message-2024/franklin-graham-thank-you.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  customConfirmationFGTY,
  React
};